import { render, staticRenderFns } from "./OnboardingSuccess.vue?vue&type=template&id=01c1a7c2&scoped=true&"
import script from "./OnboardingSuccess.vue?vue&type=script&lang=js&"
export * from "./OnboardingSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSuccess.vue?vue&type=style&index=0&id=01c1a7c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1a7c2",
  null
  
)

export default component.exports